import RegisteredDevices from './RegisteredDevices';

export default RegisteredDevices;
